import React, { useState, useEffect } from "react";
import { Container, TextField, Button, Typography, Box } from "@mui/material";
import { collection, doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../firestore-DB-config/firebase-config"; // Adjust the path
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";

const AddAboutForm = () => {
  const [aboutText, setAboutText] = useState("");
  const [clients, setClients] = useState("");
  const [projects, setProjects] = useState("");
  const [transactions, setTransactions] = useState("");
  const [customers, setCustomers] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  // Document ID for the "About Us" section
  const aboutDocId = "aboutData"; // You can set a static document ID

  // Function to convert <p> tags back to newlines for display in the form
  const convertHtmlToPlainText = (htmlText: string): string => {
    return htmlText
      .replace(/<\/p><p>/g, "\n") // Replace </p><p> with a newline
      .replace(/<\/?p>/g, ""); // Remove any remaining <p> or </p> tags
  };

  // Load existing data on component mount
  useEffect(() => {
    const loadAboutData = async () => {
      const docRef = doc(db, "aboutSection", aboutDocId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setAboutText(convertHtmlToPlainText(data.aboutText || "")); // Convert HTML to plain text with newlines
        setClients(data.stats?.clients?.toString() || "");
        setProjects(data.stats?.projects?.toString() || "");
        setTransactions(data.stats?.transactions?.toString() || "");
        setCustomers(data.stats?.customers?.toString() || "");
        setIsUpdate(true); // Switch to update mode
      }
    };

    loadAboutData();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Make sure that all fields are filled
    if (aboutText && clients && projects && transactions && customers) {
      try {
        // Use setDoc to update or add the document (with the fixed document ID)
        await setDoc(doc(db, "aboutSection", aboutDocId), {
          aboutText,
          stats: {
            clients: parseInt(clients),
            projects: parseInt(projects),
            transactions: parseInt(transactions),
            customers: parseInt(customers),
          },
        });

        alert(
          isUpdate ? "Data updated successfully!" : "Data added successfully!"
        );

        // Reset the form if you want, or keep the data for further edits
        // Optionally, you can remove these reset calls if it's an update form.
        if (!isUpdate) {
          setAboutText("");
          setClients("");
          setProjects("");
          setTransactions("");
          setCustomers("");
        }
      } catch (error) {
        console.error("Error saving data: ", error);
        alert("Failed to save data.");
      }
    } else {
      alert("Please fill all fields.");
    }
  };

  return (
    <>
      <Header />
      <Container
        maxWidth="sm"
        sx={{
          my: { xs: 4, md: 8 },
          px: { xs: 2, md: 4 },
          textAlign: { xs: "center", md: "left" }, // Responsive alignment
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontSize: { xs: "1.5rem", md: "2rem" }, fontWeight: "600" }} // Responsive typography
        >
          {isUpdate ? "Update About Us Content" : "Add About Us Content"}
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: { xs: 2, md: 4 } }} // Responsive margin top
        >
          <TextField
            label="About Us Text"
            fullWidth
            multiline
            rows={6}
            variant="outlined"
            margin="normal"
            value={aboutText}
            onChange={(e) => setAboutText(e.target.value)}
            required
            sx={{ borderRadius: "12px" }} // Rounded corners for inputs
          />
          <TextField
            label="Number of Happy Clients"
            fullWidth
            type="number"
            variant="outlined"
            margin="normal"
            value={clients}
            onChange={(e) => setClients(e.target.value)}
            required
            sx={{ borderRadius: "12px" }}
          />
          <TextField
            label="Number of Completed Projects"
            fullWidth
            type="number"
            variant="outlined"
            margin="normal"
            value={projects}
            onChange={(e) => setProjects(e.target.value)}
            required
            sx={{ borderRadius: "12px" }}
          />
          <TextField
            label="Number of Transactions"
            fullWidth
            type="number"
            variant="outlined"
            margin="normal"
            value={transactions}
            onChange={(e) => setTransactions(e.target.value)}
            required
            sx={{ borderRadius: "12px" }}
          />
          <TextField
            label="Number of Customers"
            fullWidth
            type="number"
            variant="outlined"
            margin="normal"
            value={customers}
            onChange={(e) => setCustomers(e.target.value)}
            required
            sx={{ borderRadius: "12px" }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{
              mt: 2,
              borderRadius: "12px",
              width: { xs: "100%", md: "auto" }, // Full width on small screens
              textTransform: "none", // Keep button text as-is
            }}
          >
            {isUpdate ? "Update" : "Submit"}
          </Button>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default AddAboutForm;
